import React from 'react';
import Header from './Header';

/**
 * Info and legal pages: site header, no sidebar, full width content.
 */
function InfoPageRoute({ children }) {
  return (
    <>
      <Header />
      <div className="min-h-screen pt-36 md:pt-32 overflow-x-hidden bg-dark-bg">
        {children}
      </div>
    </>
  );
}

export default InfoPageRoute;
